const routes = [
  {
    path: "/videoPatrol/plan", //巡逻计划
    name: "videoPatrol",
    component: () => import("./view/Plan.vue"),

    meta: {
      requireAuth: false
    }
  },
  // {
  //   path: '/videoPatrol/patrolTemplate', //巡逻计划模板
  //   name: 'patrolTemplate',
  //   component: () => import('./view/patrolTemplate.vue'),
  //   meta: {
  //     requireAuth: false,
  //     // routerAlive: true
  //   }
  // },
  {
    path: "/videoPatrol/patrolRecord", //巡逻记录
    name: "patrolRecord",
    component: () => import("./view/patrolRecord.vue"),
    meta: {
      requireAuth: false
      // routerAlive: true
    }
  },
  // {
  //   path: '/videoPatrol/taskNew', //巡逻任务
  //   name: 'taskNew',
  //   component: () => import('./view/taskNew.vue'),
  //   meta: {
  //     requireAuth: false,

  //   }
  // },
  // {
  //   path: '/videoPatrol/planNew', //巡更计划
  //   name: 'plan',
  //   component: () => import('./view/PlanNew.vue'),
  //   meta: {
  //     requireAuth: false,

  //   }
  // },
  {
    path: "/videoPatrol/task", //巡更任务
    name: "videoTask",
    component: () => import("./view/TaskNew.vue"),
    // component: () => import('./view/Taskyhj.vue'),
    meta: {
      requireAuth: false
      // routerAlive: true
    }
  },
  {
    path: "/videoPatrol/history", //历史任务
    name: "history",
    component: () => import("./view/patrolRecord.vue"),
    // component: () => import('./view/History.vue'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  }
];

export default routes;
